var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"AccountSummaryEmail"}},[_c('iframe-modal',{ref:"iframeModal"}),_c('Page',{attrs:{"title":_vm.$t('Summary Emails')}},[_c('Layout',[_c('LayoutSection',[_c('Card',[_c('Filters',{ref:"filters",attrs:{"filters":[
                {
                  key: 'fromDate',
                  label: this.$t('Start Date'),
                  type: 'date',
                  required: true
                },
                {
                  key: 'toDate',
                  label: this.$t('End Date'),
                  type: 'date'
                },
                {
                  key: 'type',
                  label: _vm.$t('Type'),
                  type: 'select',
                  options: [
                    { label: _vm.$t('Weekly'), value: 'weekly' },
                    { label: _vm.$t('Monthly'), value: 'monthly' }
                  ],
                  required: false
                }
              ],"shortcuts":[
                {
                  label: _vm.$t('Type'),
                  items: [
                    { label: _vm.$t('Weekly'), onAction: function () { return _vm.setType('weekly'); } },
                    { label: _vm.$t('Monthly'), onAction: function () { return _vm.setType('monthly'); } }
                  ]
                }
              ],"applied-filters":_vm.filter,"query":false,"required":""},on:{"update":_vm.updateFilter}}),_c('DataTable',{attrs:{"columns":[
                {
                  key: 'fromDate',
                  label: _vm.$t('From Date'),
                  format: 'dateLong'
                },
                {
                  key: 'toDate',
                  label: _vm.$t('To Date'),
                  format: 'dateLong'
                },
                {
                  key: 'type',
                  label: _vm.$t('Type')
                }
              ],"row-actions":[
                {
                  label: _vm.$t('View email'),
                  onAction: function (row) { return _vm.viewEmail(row.fileName); }
                }
              ],"rows":_vm.formattedEmails,"loading":_vm.loadingState,"pagination":{
                offset: _vm.offset,
                limit: _vm.limit,
                total: _vm.totalElements,
                updateOffset: _vm.updateOffset,
                updateLimit: _vm.updateLimit
              }}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }